/**
 * @hidden
 */
export var noop = function () {};